var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultGroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 219,
    viewBox: "0 0 298 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.563 83.375H211.073C206.177 64.4474 196.059 47.2701 181.871 33.7949C167.682 20.3197 149.991 11.087 130.807 7.14586C111.624 3.2047 91.7177 4.71315 73.3503 11.4998C54.983 18.2864 38.8911 30.0791 26.9033 45.5379C14.9154 60.9967 7.51225 79.5017 5.53497 98.9501C3.5577 118.399 7.08561 138.011 15.7178 155.558C24.3501 173.105 37.7405 187.884 54.3675 198.215C70.9945 208.546 90.1915 214.015 109.777 214H227.563C244.918 214 261.562 207.119 273.834 194.87C286.106 182.622 293 166.009 293 148.687C293 131.366 286.106 114.753 273.834 102.505C261.562 90.2561 244.918 83.375 227.563 83.375Z",
    stroke: "#AEC3DE",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultGroom);
export default __webpack_public_path__ + "static/media/DefaultGroom.634750cc58f52952c5f3487956f4b179.svg";
export { ForwardRef as ReactComponent };